import {combineReducers, configureStore} from "@reduxjs/toolkit";
import profileSlice from "./profile/profileSlice";
import notificationSlice from "./notification/notificationSlice";
import packageSlice from "./package/packageSlice";
import gymSettingsSlice from "./gymSettings/gymSettingsSlice";
import classesSlice from "./classes/classesSlice";
import trainersSlice from "./trainers/trainersSlice";
import classEventSlice from "./classEvents/classEventsSlice";
import siteContentSlice from "./siteContent/siteContentSlice";
import venuesSlice from "./venues/venuesSlice";
import generaContentSettingsSlice from "./generalSettings/generalSettingsSlice"
import stripeKeysSlice from "./stripeKeys/StripeKeysSlice";
import multiGymsSlice from "./multiGyms/multiGymsSlice";


const rootReducer = combineReducers({
    profileSlice,
    notificationSlice,
    gymSettingsSlice,
    classesSlice,
    trainersSlice,
    classEventSlice,
    siteContentSlice,
    venuesSlice,
    packageSlice,
    generaContentSettingsSlice,
    stripeKeysSlice,
    multiGymsSlice
});

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer
    })
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];